import { render, staticRenderFns } from "./ProductDesignFormThread2.vue?vue&type=template&id=2cff0cf8&"
import script from "./ProductDesignFormThread2.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormThread2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports